
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaisuratcabs() {



  const cardData =
  {
    keyword: 'Mumbai to Surat Cabs Service',
    heading: 'AB Ghule Cabs: Mumbai to Surat Cabs Service',
    headingDescription: 'Travel with ease and comfort with AB Ghule Cabs’ Mumbai to Surat Cabs Service. Whether you’re planning a business trip, a family vacation, or simply visiting Surat for leisure, we provide reliable, safe, and comfortable transportation. Our well-maintained vehicles and professional drivers ensure that your journey from Mumbai to Surat is smooth and enjoyable. Book your Mumbai to Surat cab now for a stress-free ride. Surat is approximately 280 km from Mumbai.',

    top: 'Top Places to Visit in Surat with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Dumas Beach",
          description: "Located on the Arabian Sea coast, Dumas Beach is a serene and scenic beach, known for its black sand and peaceful atmosphere. The beach offers a tranquil escape from the busy city life, with its cool sea breeze, perfect for evening walks, picnics, and relaxing by the shore. The place also has a unique reputation as one of the haunted beaches in India, adding a sense of intrigue to its charm."
        },
        {
          title: "Sarthana Nature Park",
          description: "Nestled within the city, Sarthana Nature Park is a lush green sanctuary offering a mix of wildlife and nature trails. Home to a variety of species, including animals, birds, and reptiles, the park is perfect for nature lovers, photographers, and families looking to escape into nature. The park features well-maintained pathways, a small zoo, and vibrant flora, making it an educational and recreational hub."
        },
        {
          title: "Surat Castle (Old Fort)",
          description: "Surat Castle, also known as the Old Fort, is a historical monument built in the 16th century to protect the city from Portuguese and Maratha invasions. It is strategically located near the Tapi River, offering panoramic views of the surrounding area. The castle’s intricate architecture, complete with bastions and defensive walls, reflects Surat's historical significance as a thriving trade center during the Mughal period."
        },
        {
          title: "Gopi Talav",
          description: "Gopi Talav is a serene and picturesque lake located in the heart of Surat. Surrounded by lush greenery, this peaceful spot is perfect for leisurely strolls and picnics. The lake offers beautiful views of the surrounding hills and is an ideal location to relax while enjoying the tranquility of nature. Gopi Talav also holds a special cultural significance, as it is often associated with several local folk tales."
        },
        {
          title: "Dumas Road",
          description: "Dumas Road is a scenic and popular route that runs parallel to the Arabian Sea. Known for its picturesque views and calm atmosphere, Dumas Road is a favorite for locals looking for a peaceful drive. Along this route, visitors can also find several traditional eateries and food stalls serving local delicacies such as 'Khichdi' and 'Bhajiya,' making it a great place to indulge in Surat’s unique food culture."
        },
        {
          title: "Iskcon Surat",
          description: "ISKCON Surat is a prominent spiritual center dedicated to Lord Krishna. Located in a peaceful area of the city, the temple features beautiful architecture and an inviting atmosphere for visitors seeking spiritual solace. The temple complex offers cultural programs, yoga classes, and a vegetarian restaurant, making it a place for both spiritual reflection and community engagement. It is also a hub for devotees from around the world."
        },
        {
          title: "Surat Science Centre",
          description: "The Surat Science Centre is an interactive learning center offering exhibits and activities that delve into various scientific concepts. With hands-on displays, a planetarium, and a 3D theater, the Science Centre is perfect for families, school groups, and anyone with an interest in science. The center encourages learning through exploration and fun, providing an engaging environment for visitors of all ages to understand the wonders of science."
        },
        {
          title: "Ambika Niketan Temple",
          description: "Located on the banks of the Tapi River, the Ambika Niketan Temple is a revered spiritual site dedicated to Goddess Ambika. Known for its peaceful ambiance, the temple is surrounded by lush gardens and beautiful architecture, making it a tranquil retreat for devotees and visitors alike. The temple attracts large crowds during festivals like Navratri and offers a peaceful space for meditation and reflection."
        },
        {
          title: "Sarthana Jain Temple",
          description: "The Sarthana Jain Temple is a remarkable religious site known for its intricate marble carvings and peaceful atmosphere. This Jain temple is dedicated to Lord Adinatha and features beautiful sculptures depicting various Jain teachings. Located in a serene part of the city, the temple offers a calm and reflective environment for worshipers and visitors interested in Jain culture and philosophy."
        },
        {
          title: "Surat Textile Market",
          description: "Surat Textile Market is the heart of the city’s thriving textile industry, offering a vast array of fabrics, textiles, and garments. Known as the 'Silk City,' Surat is a major hub for textiles in India, and the market reflects this heritage with its vibrant atmosphere. Visitors can shop for everything from high-quality silk and cotton fabrics to ready-made garments and traditional clothing, making it a shopping paradise for fashion enthusiasts."
        }
      ],


   services: [
  {
    "name": "Mumbai Surat Cab",
    description: "Looking for a reliable Mumbai to Surat cab service? AB Ghule Cabs offers comfortable and affordable cab services between Mumbai and Surat. Our fleet of well-maintained vehicles and experienced drivers ensure a smooth, timely, and pleasant journey. Whether you’re traveling for business or leisure, we prioritize your comfort and safety to make your journey enjoyable. Our service provides flexibility, whether you need a one-way trip, round-trip, or a customized itinerary for your convenience."
  },
  {
    "name": "Mumbai Surat Taxi Fare",
    description: "Get transparent and competitive pricing for your Mumbai to Surat taxi with AB Ghule Cabs. We offer affordable rates with no hidden charges, ensuring a hassle-free travel experience. Our pricing structure is designed to provide value for money, whether you're booking for a business trip, family vacation, or group travel. Contact us for a customized quote based on your travel needs, ensuring a budget-friendly and enjoyable ride from Mumbai to Surat."
  },
  {
    "name": "Mumbai Surat Cab Service",
    description: "AB Ghule Cabs offers top-quality Mumbai Surat cab services, with a focus on customer satisfaction. Whether you're traveling for business or leisure, we provide comfortable and timely cab services, ensuring a pleasant journey. Our fleet includes various vehicle options to suit your preferences and group size, ensuring you travel in comfort. Trust us for a reliable, safe, and punctual taxi service from Mumbai to Surat."
  },
  {
    "name": "Best Outstation Cab Service in Mumbai",
    description: "For the best outstation cab services in Mumbai, choose AB Ghule Cabs. We offer a range of vehicles for long-distance travel, including trips to Surat, Gujarat, and beyond. Our professional drivers ensure a smooth and safe journey, offering a comfortable and hassle-free travel experience. Whether you're going for business or leisure, we guarantee prompt service, comfortable rides, and competitive pricing. Let us make your outstation trip a pleasant one."
  },
  {
    "name": "Mumbai to Gujarat Cab",
    description: "AB Ghule Cabs provides reliable and affordable taxi services from Mumbai to various destinations in Gujarat, including Surat, Saputara, and Nandurbar. Our professional drivers ensure a safe, comfortable, and timely journey. We offer well-maintained vehicles to make your trip enjoyable, whether it's a scenic ride to Gujarat’s hill stations or a business trip. Choose AB Ghule Cabs for a convenient and pleasant taxi experience to any destination in Gujarat."
  },
  {
    "name": "Mumbai to Saputara Cab",
    description: "Traveling from Mumbai to Saputara? Book your cab with AB Ghule Cabs for a comfortable and scenic ride to this popular hill station in Gujarat. Our professional drivers ensure a smooth journey, providing you with a relaxing ride through the picturesque landscapes. Whether you're visiting for leisure, a family outing, or a weekend getaway, we ensure you travel comfortably and on time to Saputara."
  },
  {
    "name": "Mumbai to Nandurbar Cab",
    description: "For a taxi service from Mumbai to Nandurbar, AB Ghule Cabs offers timely and comfortable rides. Whether it’s a business trip or a family outing, we ensure a safe and relaxing journey. Our fleet of well-maintained vehicles and experienced drivers ensure you get to Nandurbar on time and in comfort, making it the ideal choice for your travel needs."
  },
  {
    "name": "Mumbai Airport to Surat Cab",
    description: "Looking for a reliable cab from Mumbai Airport to Surat? AB Ghule Cabs provides efficient and affordable airport transfer services. Our drivers will meet you at the airport and ensure a timely and comfortable ride to Surat. With AB Ghule Cabs, you can expect hassle-free service, with no delays, comfortable vehicles, and a smooth journey to Surat from Mumbai Airport."
  },
  {
    "name": "Mumbai to Surat Cab",
    description: "Choose AB Ghule Cabs for your Mumbai to Surat journey. We offer well-maintained cars and experienced drivers for a safe, comfortable, and timely ride. Whether you are traveling for business, leisure, or an event, we ensure a smooth and stress-free experience. Our cabs are equipped with modern amenities, ensuring a pleasant trip. Trust AB Ghule Cabs for your Mumbai to Surat ride and enjoy a safe and comfortable journey."
  },
  {
    "name": "Car Rental and Taxi Services Available",
    description: "AB Ghule Cabs provides a variety of car rental and taxi services in Mumbai, including one-way, round-trip, and customized services. Whether you're heading to Surat, a neighboring city, or any destination of your choice, we have a fleet of vehicles to suit your needs. We offer competitive rates, professional drivers, and well-maintained vehicles to ensure a comfortable and convenient travel experience."
  },
  {
    "name": "Terminal 1 Chhatrapati Shivaji Airport Mumbai to Surat Cab",
    description: "Book a cab from Mumbai Terminal 1 Airport to Surat with AB Ghule Cabs. Our drivers will ensure a timely pickup from the airport, providing you with a smooth and comfortable ride to Surat. We prioritize your convenience, offering a hassle-free journey with professional drivers who understand the importance of punctuality and safety."
  },
  {
    "name": "Andheri to Surat Cab",
    description: "Traveling from Andheri to Surat? AB Ghule Cabs offers affordable and reliable taxi services for your journey. Our well-maintained cars and professional drivers ensure a smooth, timely, and comfortable trip. Whether you’re traveling for business, leisure, or family reasons, we make sure you arrive in Surat safely and on time."
  },
  {
    "name": "One Way Taxi from Andheri to Surat",
    description: "Book a one-way taxi from Andheri to Surat with AB Ghule Cabs. We offer competitive rates for one-way journeys, ensuring a comfortable ride with no hassles. Our professional drivers provide reliable service, ensuring a smooth and timely journey, so you can focus on enjoying your trip without the stress of driving."
  },
  {
    "name": "Borivali to Surat Cab",
    description: "AB Ghule Cabs provides reliable and comfortable taxi services from Borivali to Surat. Our professional drivers and well-maintained vehicles ensure a smooth journey, whether you're traveling alone, with family, or in a group. We prioritize punctuality and customer satisfaction, making your Borivali to Surat ride a comfortable and enjoyable experience."
  },
  {
    "name": "Mumbai Airport to Surat Taxi",
    description: "For a taxi from Mumbai Airport to Surat, trust AB Ghule Cabs for a comfortable and safe ride. Our airport taxi service ensures timely pickups and smooth transfers, providing you with a hassle-free journey to Surat. Our professional drivers and well-maintained vehicles guarantee a safe, stress-free ride, so you can focus on your trip without worrying about transportation."
  },
  {
    "name": "Dadar to Surat Cabs",
    description: "Book a cab from Dadar to Surat with AB Ghule Cabs for a reliable and comfortable ride. Whether you're traveling for work or leisure, we ensure a smooth and timely journey. Our professional drivers and modern vehicles provide a stress-free travel experience from Dadar to Surat, ensuring you reach your destination on time and in comfort."
  },
  {
    "name": "Mumbai Surat Cabs Contact Number",
    description: "For prompt and efficient Mumbai to Surat cab services, contact AB Ghule Cabs at +91 8624029699. Our professional team ensures a smooth and enjoyable ride for all our customers. We prioritize safety, comfort, and punctuality, making your trip from Mumbai to Surat a stress-free and memorable experience."
  }
   ],

   tableData: [
    ["Mumbai Surat Cab", "Reliable and affordable taxi service from Mumbai to Surat"],
    ["Mumbai Surat Taxi Fare", "Competitive pricing for your Mumbai to Surat journey"],
    ["Mumbai Surat Cab Service", "Top-quality service for a smooth ride to Surat"],
    ["Mumbai to Gujarat Cab", "Easy travel options from Mumbai to Gujarat"],
    ["Mumbai to Saputara Cab", "Comfortable taxi service to Saputara from Mumbai"],
    ["Mumbai to Nandurbar Cab", "Safe and timely taxi service to Nandurbar from Mumbai"],
    ["Mumbai Airport to Surat Cab", "Convenient taxi service from Mumbai Airport to Surat"],
    ["Terminal 1 Chhatrapati Shivaji Airport Mumbai to Surat Cab", "Hassle-free cab ride from Mumbai Airport Terminal 1 to Surat"],
    ["Andheri to Surat Cab", "Quick and easy taxi ride from Andheri to Surat"],
    ["One Way Taxi from Andheri to Surat", "Affordable one-way taxi option from Andheri to Surat"],
    ["Borivali to Surat Cab", "Comfortable taxi service from Borivali to Surat"],
    ["Dadar to Surat Cabs", "Convenient taxi service for travel from Dadar to Surat"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Professional Service",
      WhyChoosedescription: "At AB Ghule Cabs, we specialize in providing reliable and professional cab services for your Mumbai to Surat travel. Whether you're traveling for business, leisure, or an emergency, our drivers are committed to providing a smooth, safe, and comfortable ride."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "We understand that travel plans can change, and that's why our services are available round-the-clock. Whether it's a last-minute trip or a pre-planned journey, our customer service is always ready to assist you with booking or inquiries."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "We offer competitive pricing with no hidden charges. Our transparent fare structure ensures that you get the best value for your money, whether it's a one-way or round trip from Mumbai to Surat."
    },
    {
      WhyChooseheading: "Clean and Well-Maintained Fleet",
      WhyChoosedescription: "Our fleet consists of a variety of clean and well-maintained vehicles, including sedans, SUVs, and luxury cars. Every vehicle is regularly inspected and serviced, ensuring a comfortable and safe journey from Mumbai to Surat."
    },
    {
      WhyChooseheading: "Experienced and Safe Drivers",
      WhyChoosedescription: "Safety is our top priority. All our drivers are highly experienced, well-trained, and background-checked. They are familiar with the best routes, ensuring you reach Surat quickly and safely."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "Booking your Mumbai to Surat cab is simple and quick. You can book via our website, mobile app, or by calling our customer service helpline. We ensure a seamless booking experience for your convenience."
    },
    {
      WhyChooseheading: "Customer Satisfaction Guarantee",
      WhyChoosedescription: "We are dedicated to providing excellent service, and our customers consistently share positive feedback. We strive to offer the best travel experience, ensuring that your journey from Mumbai to Surat is as pleasant as possible."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a Mumbai to Surat cab with AB Ghule Cabs?',
      answer: 'You can easily book a cab through our website, mobile app, or by calling our customer service helpline. Our booking process is quick and hassle-free.',
    },
    {
      id: 'FAQ2',
      question: 'Are your drivers experienced and trustworthy?',
      answer: 'Yes, all of our drivers are well-trained, highly experienced, and background-checked to ensure your safety and comfort during the trip.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for Mumbai to Surat cab service?',
      answer: 'We offer a range of vehicles to suit your needs, including sedans, SUVs, and luxury cars. Choose the one that fits your preferences for comfort and convenience.',
    },
    {
      id: 'FAQ4',
      question: 'How do I pay for my Mumbai to Surat cab ride?',
      answer: 'You can pay for your ride using multiple payment methods, including cash, credit/debit cards, or online payments via our mobile app or website for your convenience.',
    },
    {
      id: 'FAQ5',
      question: 'Are there any additional charges for detours or waiting time?',
      answer: 'Additional charges may apply for detours or waiting time, depending on your specific trip. However, all extra charges are communicated to you in advance.',
    },
    {
      id: 'FAQ6',
      question: 'How long does it take to travel from Mumbai to Surat?',
      answer: 'The travel time from Mumbai to Surat typically takes around 4 to 5 hours, depending on traffic and the route taken. Our drivers choose the most efficient routes to ensure timely arrival.',
    },
    {
      id: 'FAQ7',
      question: 'Can I modify or cancel my booking?',
      answer: 'Yes, you can easily modify or cancel your booking via our website or app. You can also contact our customer service for assistance with cancellations or changes.',
    },
    {
      id: 'FAQ8',
      question: 'Is AB Ghule Cabs available for round trips to Surat?',
      answer: 'Yes, we offer round-trip services for Mumbai to Surat and can tailor the ride to your schedule. We ensure flexibility and comfort for your return journey as well.',
    },
    {
      id: 'FAQ9',
      question: 'What makes AB Ghule Cabs different from other Mumbai to Surat cab services?',
      answer: 'AB Ghule Cabs stands out with our commitment to customer satisfaction, transparent pricing, experienced drivers, and well-maintained fleet. We offer a comfortable, safe, and hassle-free journey every time.',
    },
    {
      id: 'FAQ10',
      question: 'Can I book a Mumbai to Surat cab for a group?',
      answer: 'Yes, we provide vehicles of varying sizes, including larger cars for group travel. Please contact our customer service team for group bookings or any specific requirements.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: "Mr. Anil Deshmukh",
      feedback: "I had to travel from Mumbai to Surat for a business trip, and AB Ghule Cabs made it a seamless experience. The driver was punctual, the car was clean and comfortable, and the journey was smooth. I highly recommend them for anyone needing reliable and professional transportation.",
      rating: 5,
    },
    {
      id: 2,
      name: "Ms. Rina Patel",
      feedback: "We used AB Ghule Cabs for a family trip to Surat, and it was fantastic! The vehicle was well-maintained, the driver was friendly, and we had a very comfortable ride. I’ll definitely choose AB Ghule Cabs for my future travel needs.",
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>

<Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Mumbai Surat Taxi | Surat Cab Service</title>
  <meta name="description" content="Book Mumbai Surat cab service for a reliable and affordable ride. Get outstation taxi services from Mumbai to Surat, Saputara, Nandurbar, and more. Convenient pick-up from Mumbai Airport and local areas." />
  <meta name="keywords" content="Mumbai Surat Cab, Mumbai Surat Taxi Fare, Mumbai Surat Cab Service, Best Outstation Cab Service in Mumbai, Mumbai to Gujarat Cab, Mumbai to Saputara Cab, Mumbai to Nandurbar Cab, Mumbai Airport to Surat Cab, Mumbai to Surat Cab, Car Rental and Taxi Services Available, Terminal 1 Chhatrapati Shivaji Airport Mumbai to Surat Cab, Andheri to Surat Cab, One Way Taxi From Andheri to Surat, Borivali to Surat Cab, Mumbai Airport to Surat Taxi, Dadar to Surat Cabs" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Mumbai Surat Taxi | Surat Cab Service" />
  <meta property="og:description" content="Book Mumbai Surat cab service for a reliable and affordable ride. Get outstation taxi services from Mumbai to Surat, Saputara, Nandurbar, and more. Convenient pick-up from Mumbai Airport and local areas." />
  <meta property="og:image" content="https://abghulecabs.com/images/mumbai-surat-taxi.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/mumbai-surat-taxi" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs",
        description: "Book Mumbai Surat cab service for a reliable and affordable ride. Get outstation taxi services from Mumbai to Surat, Saputara, Nandurbar, and more. Convenient pick-up from Mumbai Airport and local areas.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Mumbai, Maharashtra",
          "addressLocality": "Mumbai",
          "addressRegion": "Maharashtra",
          "postalCode": "400001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/mumbai-surat-taxi",
        "logo": "https://abghulecabs.com/images/mumbai-surat-taxi.jpg",
        "image": "https://abghulecabs.com/images/mumbai-surat-taxi.jpg",
        "priceRange": "₹2500 - ₹6000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/mumbai-surat-taxi",
          "priceCurrency": "INR",
          "price": "2500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.6",
          "reviewCount": "1100"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya Deshmukh"
            },
            "datePublished": "2024-12-01",
            "reviewBody": "The ride from Mumbai to Surat was very comfortable. The driver was professional and the cab was well-maintained. I will surely use their services again."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rahul Mehta"
            },
            "datePublished": "2024-11-18",
            "reviewBody": "Excellent service! The cab was on time, and the journey was smooth. Highly recommend for anyone traveling from Mumbai to Surat."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Mumbai",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "19.0760",
            "longitude": "72.8777"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/mumbai-surat-taxi"
        },
        "keywords": "Mumbai Surat Cab, Mumbai Surat Taxi Fare, Mumbai Surat Cab Service, Best Outstation Cab Service in Mumbai, Mumbai to Gujarat Cab, Mumbai to Saputara Cab, Mumbai to Nandurbar Cab, Mumbai Airport to Surat Cab, Mumbai to Surat Cab, Car Rental and Taxi Services Available, Terminal 1 Chhatrapati Shivaji Airport Mumbai to Surat Cab, Andheri to Surat Cab, One Way Taxi From Andheri to Surat, Borivali to Surat Cab, Mumbai Airport to Surat Taxi, Dadar to Surat Cabs"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/8.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Mumbaisuratcabs;